exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar{width:100%;font-size:14px;line-height:18px;font-weight:300;font-family:Open Sans,sans-serif;box-sizing:border-box;color:#000}.sidebar__after-button{margin-top:5px!important;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.sidebar .place{border-bottom:1px dotted #000}.sidebar .place,.sidebar .place:hover{color:#000;text-decoration:none}.sidebar__question-btn{margin-top:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28a85918","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/sidebar/Sidebar.vue
// module id = 39a974016b508b99ef28
// module chunks = 6